import { rootActions } from '@store/slices'
import { ISendInvitationPayload } from '@store/slices/emails/sendInvitation'
import axios from '@utils/request'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'

interface TaskAction extends Action {
    payload: ISendInvitationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.emails.sendInvitation

function* sendInvitationSagaTask({ payload }) {
    try {
        const response = yield axios.post(`notifications/emails/send-invitation`, { ...payload.data })

        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB) {
                payload?.sagaCB?.onSuccess(response.result)
            }
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* sendInvitationSaga(): any {
    yield takeLatest<TaskAction>(onRequest, sendInvitationSagaTask)
}

export default sendInvitationSaga
